import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e8953c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "人脸识别系统")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 人脸检测 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 人脸相似度 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 人脸识别 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 视频流识别 ")
const _hoisted_8 = { class: "main" }

import {onUnmounted, onMounted, reactive} from 'vue'
import {NavigationGuardNext, RouteLocationNormalized, useRouter} from 'vue-router'
import {User, Avatar, Opportunity, Cherry} from '@element-plus/icons-vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

console.log('App')
const router = useRouter()
const state = reactive<any>({
  defaultOpen: ['1'],
  showMenu: true,
  currentPath: '/',
  count: {
    number: 1
  }
})


const unwatch = router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  next()
  state.currentPath = to.path
})

onUnmounted(() => {
  unwatch()
})


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_submenu = _resolveComponent("el-submenu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(state).showMenu)
      ? (_openBlock(), _createBlock(_component_el_container, {
          key: 0,
          class: "container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_aside, { class: "aside" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _hoisted_3,
                _createVNode(_component_el_menu, {
                  "default-openeds": _unref(state).defaultOpen,
                  "background-color": "#222832",
                  "text-color": "#fff",
                  router: true,
                  "default-active": _unref(state).currentPath
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_submenu, { index: "1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_menu_item, { index: "/faceDetect" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Avatar))
                                  ]),
                                  _: 1
                                }),
                                _hoisted_4
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_menu_item, { index: "/faceCompare" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(User))
                                  ]),
                                  _: 1
                                }),
                                _hoisted_5
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_menu_item, { index: "/faceRecognition" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Cherry))
                                  ]),
                                  _: 1
                                }),
                                _hoisted_6
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_menu_item, { index: "/faceStream" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, { size: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Opportunity))
                                  ]),
                                  _: 1
                                }),
                                _hoisted_7
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["default-openeds", "default-active"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, { class: "content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_router_view)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_el_container, {
          key: 1,
          class: "container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }))
  ]))
}
}

})